import * as H from 'history';

import { IAccount } from '@share/common-types';
import { getBookRoutePath, isDisplayCertificates, isVacationRentalsFromPath } from '@share/utils';

export interface ICertificateNavigationState {
  certificateId: string;
  certificateItemId?: string;
}

export const getHotelReserveUrl = (
  hotelId: number,
  selectedPackageId: string,
  history: H.History<H.LocationState>,
  isStaticDetail?: boolean,
): string =>
  getBookRoutePath(
    hotelId,
    selectedPackageId,
    history,
    isVacationRentalsFromPath(history),
    isStaticDetail,
  );

export const getCertificateNavigationState = (
  account: IAccount | null | undefined,
  certificateId: string | undefined,
  certificateItemId: string | undefined,
): ICertificateNavigationState | undefined => {
  if (!isDisplayCertificates(account as IAccount)) {
    return undefined;
  }

  const id = certificateId?.trim();

  if (!id) {
    return undefined;
  }

  const itemId = certificateItemId?.trim();

  return { certificateId: id, ...(itemId ? { certificateItemId: itemId } : {}) };
};

/**
 * How much client cash carries into the review step. Wallet savings accounts
 * push the maximum permitted amount; everyone else keeps whatever the guest
 * already chose on the property.
 */
export interface IWalletPriceSummary {
  priceSavings?: number;
  maxClientCashAmountAllow?: number;
  maxClientCashPermited?: number;
}

export const resolveReviewClientCash = (
  account: IAccount | null | undefined,
  walletPrices: IWalletPriceSummary | null | undefined,
  selectedPropertyClientCash: number | null | undefined,
): number | undefined => {
  const displayWalletSavings =
    account?.walletWalletSavings &&
    ((walletPrices?.priceSavings || 0) > 0 || (walletPrices?.maxClientCashAmountAllow || 0) > 0) &&
    walletPrices?.maxClientCashAmountAllow;

  return displayWalletSavings
    ? walletPrices?.maxClientCashPermited
    : selectedPropertyClientCash ?? undefined;
};
